import { TextField, Typography, InputAdornment, IconButton, Button } from '@mui/material';
import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { roundedFieldSx } from '../shared/authFieldStyles';

const SignupFormEmail = ({ formData, handleChange, handleSubmit }) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => setShowPassword(!showPassword);

  return (
    <>
      <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mt: 1 }}>Email</Typography>
      <TextField
        name="email"
        fullWidth
        margin="normal"
        value={formData.email}
        onChange={handleChange}
        sx={roundedFieldSx}
      />

      <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mt: 1 }}>Password</Typography>
      <TextField
        name="password"
        type={showPassword ? 'text' : 'password'}
        fullWidth
        margin="normal"
        value={formData.password}
        onChange={handleChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleTogglePasswordVisibility}>
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={roundedFieldSx}
      />

      <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mt: 1 }}>Confirm Password</Typography>
      <TextField
        name="confirm_password"
        type="password"
        fullWidth
        margin="normal"
        value={formData.confirm_password}
        onChange={handleChange}
        sx={roundedFieldSx}
      />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ borderRadius: '30px', mt: 2 }}
        onClick={handleSubmit}
      >
        Create Account
      </Button>
    </>
  );
};

export default SignupFormEmail;
